<div class="player-profile-tab-content-top0">
  <div class="pb-2_5">
    @if (isPro) {
      @if (errorMsg || isLoading) {
        <div class="pt-3">
          <app-loading [active]="isLoading" [center]="true"/>
          <app-message [active]="!!errorMsg" [message]="errorMsg"/>
        </div>
      }

      @if (data && !isLoading) {
        <div class="flex align-items-center py-2">
          <div>
            {{(view.isMobile ? 'UPCOMING' : 'UPCOMING_EVENTS') | translate}}:&nbsp;{{upcomingEvents}}
          </div>
          <div class="flex-1"></div>
          <div class="flex align-items-center gap-0 md:gap-2">
            <app-player-profile-calendar-notification/>
            <p-divider layout="vertical"/>
          </div>
          <div>
            <p-button icon="pi pi-step-backward"
                      class="button-no-background"
                      styleClass="p-button-text text-white"
                      [disabled]="previousEventDisabled"
                      [pTooltip]="'FIRST_EVENT' | translate" tooltipPosition="left" [showDelay]="400"
                      (click)="selectEvent(-2)"/>

            <p-button icon="pi pi-chevron-left"
                      class="button-no-background"
                      styleClass="p-button-text text-white"
                      [disabled]="previousEventDisabled"
                      [pTooltip]="'PREVIOUS_EVENT' | translate" tooltipPosition="left" [showDelay]="400"
                      (click)="selectEvent(-1)"/>
            <p-button icon="pi pi-chevron-right"
                      class="button-no-background"
                      styleClass="p-button-text text-white"
                      [disabled]="nextEventDisabled"
                      [pTooltip]="'NEXT_EVENT' | translate" tooltipPosition="left" [showDelay]="400"
                      (click)="selectEvent(1)"/>

            <p-button icon="pi pi-step-forward"
                      class="button-no-background"
                      styleClass="p-button-text text-white"
                      [disabled]="nextEventDisabled"
                      [pTooltip]="'LAST_EVENT' | translate" tooltipPosition="left" [showDelay]="400"
                      (click)="selectEvent(2)"/>
          </div>
        </div>

        @if (!reload) {
          <p-datePicker #datePicker class="max-w-full" styleClass="w-full" [inline]="true" [showWeek]="false"
                        [(ngModel)]="selectedDate" (ngModelChange)="onDateSelected()"
                        (onMonthChange)="monthChanged($event)"
                        [numberOfMonths]="numberOfMonths">
            <ng-template #date let-date>
              @if (isDateSelectedFuture(date)) {
                <span class="datepicker-accent p-datepicker-day">
                  <strong>{{ date.day }} </strong>
                </span>
              } @else if (isDateSelectedBack(date)) {
                <span class="datepicker-accent bg-gray-500 text-white p-datepicker-day">
                  <strong>{{ date.day }} </strong>
                </span>
              } @else {
                {{ date.day }}
              }
            </ng-template>
          </p-datePicker>
        }

        @if (selectedDate) {
          <div class="pt-1 md:pt-2">
            @if (selectedDate.getFullYear() === today.getFullYear() && selectedDate.getMonth() === today.getMonth() && selectedDate.getDate() === today.getDate()) {
              <h3>{{'TODAY' | translate}}</h3>
            } @else {
              <h3>{{selectedDate | date : 'mediumDate'}}</h3>
            }
            <app-player-profile-calendar-table [data]="dataSelectedDate" (reloadData)="loadData()"/>
          </div>
        }

        @if (upcomingEvents === 0) {
          <div class="pt-3">
            <p-panel [header]="'TOURNAMENT_REGISTRATION' | translate">
              <p class="m-0 pb-2">
                {{'TOURNAMENT_REGISTRATION_TEXT' | translate}}
              </p>
              <a href="https://2k-dartsoftware.freshdesk.com/support/solutions/articles/103000387658" target="_blank">{{'TOURNAMENT_REGISTRATION_HOWTO' | translate}}</a>
            </p-panel>
          </div>
        }
      }

      @if (playerProfile) {
        <p-divider align="left" class="pt-2">
          <div class="inline-flex gap-2 align-items-center">
            <i class="pi pi-file-export"></i>
            <b>{{'EXPORT_TO_CALENDAR' | translate}}</b>
          </div>
        </p-divider>
        <div>
          {{ 'PLAYER_PROFILE_EXPORT_CALENDAR_TEXT' | translate }}
        </div>
        <div class="flex gap-2 flex-column md:flex-row md:align-items-center pt-3">
          <div class="md:flex-1">
            <app-switch [(value)]="playerProfile.icsActive" label="CALENDAR_EXPORT_ACTIVE" class="pt-1"
                        (valueChange)="saveIcsActive()" [disabled]="isSavingIcs"/>
          </div>
          @if (playerProfile.icsFilename) {
            <p-button [label]="'COPY_CALENDAR_URL_TO_CLIPBOARD' | translate"
                      icon="pi pi-copy" styleClass="p-button-text"
                      [cdkCopyToClipboard]="playerProfile.icsFilename"
                      [pTooltip]="playerProfile.icsFilename" [showDelay]="400"
                      (onClick)="restErrorHelper.showInfoMessageService('COPIED_TO_CLIPBOARD', 2000)"/>
          }
        </div>
        @if (playerProfile.icsFilename) {
          <div class="pt-3 flex flex-column md:flex-row md:align-items-center gap-2">
            <p-button [label]="'SUBSCRIBE_IN_YOUR_CALENDAR' | translate"
                      icon="pi pi-book" styleClass="p-button-outlined"
                      (onClick)="subscribeInYourCalendar()"/>

            <p-button [label]="('SUBSCRIBE_IN_APPLE_CALENDAR' | translate) + ' (' + ('ONLY_ON_APPLE_DEVICED' | translate) + ')'"
                      (onClick)="subscribeInAppleCalendar()" styleClass="p-button-outlined"/>
          </div>
        }
      }

    } @else {
      <app-player-profile-pro-feature/>
    }
  </div>
</div>
